import { type EventEmitter, type FunctionalComponent, h } from '@stencil/core';
import { widgetStatistics } from '../../offsites-widget-statistics';

export interface OffsitesWidgetV4EventsLayer {
  eventEmitter: EventEmitter;
  tabName: string;
  widgetName: string;
}

export const OffsitesWidgetV4EventsLayer: FunctionalComponent<
  OffsitesWidgetV4EventsLayer
> = (props, children) => {
    const invokeEvent = (e) => {
        const elementsWithAreas = [
          ...e.composedPath().filter((el) => el.dataset?.widgetArea),
        ][0];
        const widgetArea = elementsWithAreas?.dataset?.widgetArea;
        const widgetLink = elementsWithAreas?.getAttribute('href');

        return widgetStatistics.sendUserRedirectionStatisticsEvent(
          widgetArea,
          'offsite banner v2 default',
          props.widgetName,
          props.tabName,
          getClickType(e),
          widgetLink,
        );
    };

    const getClickType = (e): 'left' | 'right' | 'Enter' => {
        if (e.key === 'Enter') return e.key;
        if (e.button === 0) {
          return 'left';
        } else {
          return 'right';
        }
    };

    if (props.tabName)
      props.eventEmitter.emit(
        widgetStatistics.sendPresentationStatisticsEvent(
          props.tabName,
          'default',
          true,
          props.widgetName,
        ),
      );

    return (
      <host
        onMouseDown={(e) => {
            props.eventEmitter.emit({ ...invokeEvent(e) });
        }}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
              props.eventEmitter.emit({ ...invokeEvent(e) });
            }
        }}
      >
        {children}
      </host>
    );
};
